import { agentWsClient } from '@libs/websocket-client';
import type { ChatAttachment, StreamEvent, ThreadMessages, ThreadSummary } from '../models';
import { AgentChatError, normalizeStreamEvent } from '../models';
import type { ThreadMessagesFrame } from '../models/threadMessagesFrame';
import { isThreadMessagesComplete, mergeThreadMessagesFrames } from '../models/threadMessagesFrame';

export type { StreamEvent, ThreadMessages, ThreadSummary };
export { AgentChatError };

export async function sendMessageWebSocket(
  params: {
    message: string;
    companyCode: string;
    threadId?: string;
    approvalDecision?: {
      approvalId: string;
      decision: string;
      reason?: string;
      editMessage?: string;
    } | null;
    attachments?: ChatAttachment[];
  },
  onEvent: (event: StreamEvent) => void,
  signal?: AbortSignal,
): Promise<void> {
  return agentWsClient.sendAndStream(
    {
      action: 'sendMessage',
      message: params.message,
      companyCode: params.companyCode,
      threadId: params.threadId || '',
      approvalDecision: params.approvalDecision ?? null,
      ...(params.attachments?.length ? { attachments: params.attachments } : {}),
    },
    (raw) => onEvent(normalizeStreamEvent(raw)),
    { signal },
  );
}

export function listThreads(): Promise<{ threads: ThreadSummary[] }> {
  return agentWsClient.sendAndReceive({ action: 'listThreads' });
}

export async function getThread(threadId: string): Promise<ThreadMessages> {
  // 長い履歴は 128KB のフレーム上限を超えるためサーバーが分割して push する。
  const frames = await agentWsClient.sendAndReceiveMany<ThreadMessagesFrame>(
    { action: 'getThread', threadId },
    isThreadMessagesComplete,
  );
  return mergeThreadMessagesFrames(frames);
}

export function deleteThread(threadId: string): Promise<{ threadId: string }> {
  return agentWsClient.sendAndReceive({ action: 'deleteThread', threadId });
}
